import {formatDate} from "@vueuse/core";

export const handleTree = (data, id, parentId, children) =>  {
    let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
    };

    let childrenListMap = {};
    let nodeIds = {};
    let tree = [];

    for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
            childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
    }

    for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
            tree.push(d);
        }
    }

    for (let t of tree) {
        adaptToChildrenList(t);
    }

    function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
            o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
            for (let c of o[config.childrenList]) {
                adaptToChildrenList(c);
            }
        }
    }
    return tree;
}

export const collectIds = (node, ids = []) => {
    if (node.id !== undefined) {
        ids.push(node.id);
    }
    if (node.children && Array.isArray(node.children)) {
        node.children.forEach(child => {
            collectIds(child, ids);
        });
    }
    return ids;
}

export const handleOpen = (ref, data) => {
    if (ref.value) {
        ref.value.handleOpen(data);
    } else {
        ref.handleOpen(data);
    }
}

// 根据时间返回欢迎词
export function getGreeting() {
    const now = new Date();
    const hour = now.getHours();

    let greeting;

    if (hour >= 5 && hour < 12) {
        greeting = "早上好";
    } else if (hour >= 12 && hour < 14) {
        greeting = "中午好";
    } else if (hour >= 14 && hour < 18) {
        greeting = "下午好";
    } else if (hour >= 18 && hour < 22) {
        greeting = "晚上好";
    } else {
        greeting = "晚上好";
    }

    return greeting;
}

// 根据当前时间获取格式日期和星期几
export function getFormattedDate() {
    const daysOfWeek = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要加 1，并补零
    const day = String(date.getDate()).padStart(2, '0');
    const dayOfWeek = daysOfWeek[date.getDay()];

    const formattedDate = `${year}-${month}-${day}`;
    return { formattedDate, dayOfWeek };
}

// 根据给定日期范围返回起止时间
export function getDateRange(days) {
    if (typeof days!== 'number' || days < 0) {
        throw new Error('输入的天数必须是一个大于或等于 0 的数字');
    }
    const today = new Date();
    const endDate = today;

    // 计算起始日期，将当前日期的天数减去给定的天数
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - days);

    // 格式化日期为 yyyy-MM-dd
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    return {
        startDate: formatDate(startDate),
        endDate: formatDate(endDate)
    };
}

// 判断是否移动端
export function isMobileDevice() {
    // 检查视口宽度是否小于等于 768px
    return window.matchMedia("(max-width: 768px)").matches;
}

export const debounce = (func, delay) => {
    let timer = null;
    return (...args) => {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
};


// 数据小数位处理
export function formatNumber(data, decimalPlaces) {
    // 参数校验和预处理
    const num = Number(data);
    const places = Math.max(0, Math.floor(Number(decimalPlaces) || 0));

    // 数字有效性检查
    if (isNaN(num)) return 0;

    // 处理保留小数位
    const factor = Math.pow(10, places);
    return Math.round(num * factor) / factor;
}


export function formatDateStr(dataTimeStr, formatter = "YYYY-MM-dd") {
    const date = new Date(dataTimeStr);
    return formatDate(date,formatter)
}


// 构造表格数据
export function generateTestData(length, columns = dataColumns, overrideValues = {}) {
    // 过滤不需要处理的列（操作、序号）
    const filteredColumns = columns.filter(
      col => col.title !== '操作' && col.title !== '序号'
    )

    // 生成当前时间字符串
    const getCurrentTime = () => {
        const date = new Date()
        const pad = num => num.toString().padStart(2, '0')
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    }

    // 构造数据
    const data = []
    for (let i = 0; i < length; i++) {
        const item = {}
        filteredColumns.forEach(col => {
            const key = col.key
            // 优先使用覆盖值
            if (Object.hasOwn(overrideValues, key)) {
                const overrideValue = overrideValues[key]
                // 支持函数动态值（如：duration: i => i * 10）
                item[key] = typeof overrideValue === 'function' ? overrideValue(i) : overrideValue
            }
            // 时间类型字段
            else if (key.endsWith('Time')) {
                item[key] = getCurrentTime()
            }
            // 状态字段
            else if (key === 'status') {
                item[key] = Math.floor(Math.random() * 4)
            }
            // 普通字段
            else {
                item[key] = `${col.title}${i + 1}`
            }
        })
        data.push(item)
    }

    return data
}

